import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: require("./locales/en/translation.json")
        },
        he: {
            translation: require("./locales/he/translation.json")
        },
        es: {
            translation: require("./locales/es/translation.json")
        }
    },
    lng: localStorage.getItem("language") || "en", // Default language (persists user choice)
    fallbackLng: "en", // Fallback language if the translation is missing
    interpolation: {
        escapeValue: false // React already protects against XSS
    }
});

export default i18n;
